import React from 'react';

import ServerErrorsBanner from '../../../../../../common/components/indicators/server-error/ServerErrorsBanner';
import Spinner from '../../../../../../common/components/overlays/spinner/Spinner';
import { ConvertibleFilingTalkRanges } from '../../../../../../common/hooks/useConvertibleFilingTalkRanges';
import { OfferingType } from '../../../../../../graphql';
import SectionHeader from '../../../../components/section-header/SectionHeader';
import { useUpdateHistory_CoveredIndicationVersionsQuery } from './graphql';
import { IndicationUpdateHistoryList } from './IndicationUpdateHistoryList';

export type Props = {
  offeringId: string;
  indicationId: string;
  pricingCurrencyCode?: string | null;
  securityTypeDisplayName: string | null;
  issuerName: string | null;
  convertibleTalkRanges: ConvertibleFilingTalkRanges;
  isIndicationPriceAsPercentageParEnabled: boolean | null;
  offeringType: OfferingType | null;
};

const CoveredIndicationUpdateHistory: React.FC<Props> = ({
  offeringId,
  indicationId,
  pricingCurrencyCode,
  securityTypeDisplayName,
  issuerName,
  convertibleTalkRanges,
  isIndicationPriceAsPercentageParEnabled,
  offeringType,
}) => {
  const { data, loading, error } = useUpdateHistory_CoveredIndicationVersionsQuery({
    variables: { offeringId, indicationId },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  return (
    <div>
      <SectionHeader title="History" />
      {loading && <Spinner show={true} fullHeight={true} />}
      {!loading && error && <ServerErrorsBanner error={error} />}
      {!loading && data && (
        <IndicationUpdateHistoryList
          issuerName={issuerName}
          indicationVersions={data?.coveredIndicationVersions!}
          pricingCurrencyCode={pricingCurrencyCode}
          securityTypeDisplayName={securityTypeDisplayName}
          convertibleTalkRanges={convertibleTalkRanges}
          isIndicationPriceAsPercentageParEnabled={isIndicationPriceAsPercentageParEnabled}
          offeringType={offeringType}
        />
      )}
    </div>
  );
};

export default CoveredIndicationUpdateHistory;
